import { Alert, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

const { mediaQueries, media } = theme;

export const OfferTongueWrapper = styled.div<{ displayOffer: boolean }>`
  display: ${({ displayOffer }) => (displayOffer ? 'block' : 'none')};
  @media (min-width: ${media.md}) {
    display: block;
    position: absolute;
    top: 14.25rem;
    left: 41.75rem;
  }
`;

export const PlaneVideoWrapper = styled.div`
  display: none;

  ${mediaQueries.above(media.lg)} {
    display: block;
    position: absolute;
    z-index: 1;
    top: 6.5rem;
    left: 25rem;
  }

  ${mediaQueries.above(media.xl)} {
    left: 27.25rem;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  padding: 4rem 1rem;

  ${mediaQueries.above(media.lg)} {
    padding: 6rem 2.5rem 1.75rem;
  }
`;

export const SubtitleWrapper = styled.div`
  margin-bottom: 1.5rem;
  margin-top: 1rem;
  ${mediaQueries.above(media.md)} {
    margin-bottom: 0;
    max-width: 36rem;
  }
`;

export const OverflowWrapper = styled.div`
  height: 31.25rem;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 0;
`;

export const HeaderWrapper = styled.div`
  position: relative;
`;

export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${theme.mediaQueries.above(theme.media.md)} {
    flex-direction: row;
    gap: 2rem;
    padding: 0 1.5rem;
  }

  ${theme.mediaQueries.above(theme.media.lg)} {
    padding: 0;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledAlert = styled(Alert)`
  border: none;
  display: flex;
  margin-bottom: 0;
  padding: 1rem;
  text-align: center;
`;
